module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2CAYAAACMRWrdAAAAAXNSR0IArs4c6QAAANhJREFUaAXtmcENgzAQBOM0kT5SWgpJafSRKkD5ItBKK9CurOGHT+c7z5x44PG4+Xm9P+tRid/yHUfrV609r9qobR8O1mZE9YMxRagtjrE2I6ofjClCbXGMtRlR/WBMEWqLY6zNiOoHY4pQWxxjbUZUPxhThNriGGszovoZZ//9VGJ7nFFsN7TvD2N7Iu3v0xq79cbjb/Xsq8ttiznz044iBzMnIpaGsRh6szDGTHCxNIzF0JuFMWaCi6VhLIbeLIwxE1wsDWMx9GZhjJngYmkYi6E3C09rbAOTKQoka+GODwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/app/images/icons/plus@3x.png
// module id = 613
// module chunks = 0